import { useCallback, useEffect, useRef } from 'react';
import { useResizeObserver } from './useResizeObserver';
/**
 * Хук, навешивающий на элемент обработчик изменений размеров элемента.
 *
 * @param callback Колбэк для ResizeObserver
 * @returns Функция setRef, с помощью которой надо выставить ref на наблюдаемый элемент
 */
export function useResizeListener(callback) {
    const ref = useRef(null);
    const callbackRef = useRef(callback);
    const observer = useResizeObserver((entry) => {
        requestAnimationFrame(() => {
            callbackRef.current(entry, ref.current);
        });
    });
    const setRef = useCallback(node => {
        if (!observer) {
            return;
        }
        if (node) {
            observer.observe(node);
        }
        if (ref.current) {
            observer.unobserve(ref.current);
        }
        ref.current = node;
    }, [observer]);
    useEffect(() => {
        return () => {
            if (!observer) {
                return;
            }
            ref.current && observer.unobserve(ref.current);
        };
    }, [observer]);
    return setRef;
}
